import {
    CREATE_SLA, 
    FETCH_SLA_LIST, 
    UPDATE_SLA,
    TOGGLE_SLA,
    REORDER_SLA_ORDER,
    REVERT_SLA_ORDER,
    FETCH_SLA_SETTINGS,
    UPDATE_SLA_SETTINGS
} from  './actionTypes'
import { SET_CURRENT_SM } from '../../edit/actions';

import {
    storeSlaList, 
    createSlaInStore, 
    updateSlaInStore, 
    toggleSlaInStore, 
    removeOrRevertSla, 
    fetchOrUpdateSlaSettings, 
    fetchSlaSettingsFailed
} from './utils'


const initialStore = {
    data: {},
    currentSmId: ''
}

export const slaReducer = (store=initialStore, action) => {
    const {type, payload} = action;

    switch(type){

        case SET_CURRENT_SM: {
          return {
              ...store,
              currentSmId: payload
          }
        }
        case `${FETCH_SLA_LIST}_SUCCESS`: {
           return storeSlaList(store, payload);
        }

        case `${CREATE_SLA}_SUCCESS`:{
            return createSlaInStore(store, payload)
        }

        case `${UPDATE_SLA}_SUCCESS`:{
            return updateSlaInStore(store, payload);
        }

        case `${TOGGLE_SLA}_SUCCESS`:{
            return toggleSlaInStore(store, payload);
        }

        case REORDER_SLA_ORDER:
        case REVERT_SLA_ORDER:{
            return removeOrRevertSla(store, payload);
        }

        case `${FETCH_SLA_SETTINGS}_SUCCESS`:
        case `${UPDATE_SLA_SETTINGS}_SUCCESS`:{
            return fetchOrUpdateSlaSettings(store, payload);
        }

        case `${FETCH_SLA_SETTINGS}_FAILED`:{
             return fetchSlaSettingsFailed(store);
        }

        default: return store;
    }

}